import { height } from "@mui/system";
import React, { useState, useEffect } from "react";
import { Text, View, Image, ScrollView, ActivityIndicator, StyleSheet } from "react-native";
import Icon from 'react-native-vector-icons/FontAwesome';

const BlogDetail = props => {
    return (
        <ScrollView>
            <View style={styles.container}>
                <Text style={styles.titleheader}>{props.route.params.blog.title}</Text>
               
                <View style={{ flexDirection: 'row', padding: 0, margin: 0 }}>
                    <Text style={{ flex: 1, textAlign: 'center', fontFamily: 'IranSans', fontSize: 12, margin: 0, padding: 5 }}>{props.route.params.blog.dt_reg} <Icon name="calendar" size={20} color="gray" /></Text>
                    <Text style={{ flex: 1, textAlign: 'center', fontFamily: 'IranSans', fontSize: 12, margin: 0, padding: 5 }}>{props.route.params.blog.likes} <Icon name="heart-o" size={20} color="red" /></Text>
                </View>



                
                <View style={{ flexDirection:'row',flexWrap: 'wrap',justifyContent:'center' }}>
                    <Image source={props.route.params.blog.image} style={styles.img} />

<View
                    style={{
                        borderWidth: 0.5,
                        borderColor: '#d7d7d7'
                        , width: '100%', padding: 0, margin: 0,
                    }}
                />

                    <Text style={styles.contenttext}>
                        {props.route.params.blog.content}
                    </Text>
                </View>


            </View>
        </ScrollView>
    )
}


const styles = StyleSheet.create({
    container: {

        flexWrap: 'wrap',
        justifyContent: 'center',
        margin: 10, backgroundColor: 'white',
        marginBottom: 0,
    },
    titleheader: {
        fontFamily: 'IranSans',
        fontSize: 14,
        fontWeight: 900,
        textAlign: 'center',
        margin: 10,
        padding: 8,
        backgroundColor: 'rgb(2, 42, 76)'
        , borderRadius: 3, color: 'white'
    },
    img: {
        width: 200,
        height: 200,marginBottom:30
    }
    , contenttext: {
        fontFamily: 'IranSans',
        fontSize: 14,
        textAlign: 'justify',
        padding: 10,
        lineHeight: 35, direction: 'rtl',color:'black',
    }
})

export default BlogDetail;